import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { FormItem } from "../FormItem";

export const SendUsAMessageForm = () => (
  <div className="flex max-h-full flex-col px-6">
    <FormItem className="!pt-2" name="text">
      <Form.Input name="text" variant="textarea" className="resize-none" />
    </FormItem>
    <div className="my-6 flex justify-between">
      <button
        className="bg-circle px-6 py-2.5 font-bold leading-5 text-white hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
        type="submit"
      >
        {t("support_widget.send_message_form.button_label")}
      </button>
    </div>
  </div>
);
